import { RouterModule, Routes } from '@angular/router';
import { NotificationsListComponent } from './components/list/notifications-list.component';
import { NgModule } from '@angular/core';
import { AuditLogComponent } from './components/audit-log/audit-log.component';

export const routes: Routes = [
	{
		path: '',
		component: NotificationsListComponent
	},
	{
		path: 'audit-log/:importId',
		component: AuditLogComponent,
		pathMatch: 'full',
		data: {
			title: 'Audit Log'
		}
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class NotificationsRoutingModule { }
